// General
const font = {
    'font-body': "'Inter', sans-serif",
}

// Basic colors
const base = {
    'color-white': '#FFFFFF', // rgb(255, 255, 255)
}

// Dark colors
const dark = {
    'color-dark-base': '#1C1D1F', // rgb(28, 29, 31)
    'color-dark-light': '#303032', // rgb(48, 48, 50)
    'color-dark-lighter': '#3D3E42', // rgb(61, 62, 66)
    'color-dark-lightest': '#4B4C50', // rgb(75, 76, 80)
}

// Text colors
const text = {
    'color-text-base': '#FFFFFF', // rgb(255, 255, 255)
    'color-text-darker': '#FFFFFFA6', // rgba(255, 255, 255, 0.65)
    'color-text-gray': '#848890', // rgb(132, 136, 144)
    'color-text-black': '#1C1D1F', // rgb(28, 29, 31)
}

// Border color
const border = {
    'color-border': '#FFFFFF24', // rgba(255, 255, 255, 0.14)
}

// Brand colors
const brand = {
    'color-brand-white': '#FFFFFF', //
    'color-brand-base': '#5060F1', // rgb(80, 96, 241)
    'color-brand-yellow': '#FFCC33', // rgb(255, 204, 51)
    'color-brand-gold': '#FFC400', // rgb(255, 196, 0)
    'color-brand-teal': '#66DDDD', // rgb(102, 221, 221)
    'color-brand-red': '#E44646', // rgb(228, 70, 70)
}

// Status colors
const state = {
    'color-state-red': '#EB1346', // rgb(235, 19, 70)
    'color-state-green': '#3CB44B', // rgb(60, 180, 75)
    'color-state-orange': '#EEAE53', // rgb(238, 174, 83)
    'color-state-orangeSoft': '#EEAE531F', // rgba(238, 174, 83, 0.12)
    'color-state-yellow': '#FFCC33', // rgb(255, 204, 51)
}

// Specific colors
const custom = {
    'color-stoodOut': '#F46A63', // rgb(244, 106, 99)
    'color-avgJumps': '#CC87EE', // rgb(204, 135, 238)
    'color-strikePower': '#D64081', // rgb(214, 64, 129)
    'color-direction-left': '#4BC9F1', // rgb(75, 201, 241)
    'color-direction-right': '#FDE441', // rgb(253, 228, 65)
}

// Banner and button colors
const banner = {
    'color-banner-info': '#5060F1', // rgb(80, 96, 241)
    'color-banner-warning': '#FFCC33', // rgb(255, 204, 51)
    'color-banner-danger': '#E44646', // rgb(228, 70, 70)
}

// Banner and button colors
const button = {
    'color-button-base': '#5060F1', // rgb(80, 96, 241)
    'color-button-warning': '#FFCC33', // rgb(255, 204, 51)
    'color-button-danger': '#E44646', // rgb(228, 70, 70)
    'color-button-dark-lighter': '#3D3E42', // rgb(61, 62, 66)
    'color-button-dark-lightest': '#FFFFFF1F', // rgba(255, 255, 255, 0.12)
}

// Gait colors
const gaits = {
    'color-gaits-canter': '#6655FF', // rgb(102, 85, 255)
    'color-gaits-trot': '#5B8FFF', // rgb(91, 143, 255)
    'color-gaits-walk': '#17CDCE', // rgb(23, 205, 206)
    'color-gaits-standing': '#A9D3CC', // rgb(169, 211, 204)
    'color-gaits-all': '#CC87EE', // rgb(204, 135, 238)
}

// Colors for polar zones
const polar = {
    'color-polar-zone1': '#C2CACA', // rgb(194, 202, 202)
    'color-polar-zone2': '#46C7EE', // rgb(70, 199, 238)
    'color-polar-zone3': '#6ACC2B', // rgb(106, 204, 43)
    'color-polar-zone4': '#F9BF1C', // rgb(249, 191, 28)
    'color-polar-zone5': '#DE0F5B', // rgb(222, 15, 91)
}

// Gradient table
const gradient = {
    'color-gradient-1': '#D2FF28', // rgb(210, 255, 40)
    'color-gradient-2': '#D4EA2F', // rgb(212, 234, 47)
    'color-gradient-3': '#D7D535', // rgb(215, 213, 53)
    'color-gradient-4': '#D7C13A', // rgb(215, 193, 58)
    'color-gradient-5': '#DCAB42', // rgb(220, 171, 66)
    'color-gradient-6': '#DE9749', // rgb(222, 151, 73)
    'color-gradient-7': '#E1814F', // rgb(225, 129, 79)
    'color-gradient-8': '#E36C56', // rgb(227, 108, 86)
    'color-gradient-9': '#E6575B', // rgb(230, 87, 91)
    'color-gradient-10': '#E74262', // rgb(231, 66, 98)
}

// Colors for disciplines
const discipline = {
    'color-discipline-jumping-main': '#5B3479', // rgb(91, 52, 121)
    'color-discipline-jumping-secondary': '#310057', // rgb(49, 0, 87)
    'color-discipline-dressage-main': '#3339EB', // rgb(51, 57, 235)
    'color-discipline-dressage-secondary': '#052C71', // rgb(5, 44, 113)
    'color-discipline-cross-main': '#5CD66A', // rgb(92, 214, 106)
    'color-discipline-cross-secondary': '#096006', // rgb(9, 96, 6)
    'color-discipline-endurance-main': '#FFC300', // rgb(255, 195, 0)
    'color-discipline-endurance-secondary': '#EDD77D', // rgb(237, 215, 125)
    'color-discipline-racing-main': '#FF0000', // rgb(255, 0, 0)
    'color-discipline-racing-secondary': '#571305', // rgb(87, 19, 5)
    'color-discipline-harness-racing-main': '#FF0000', // rgb(255, 0, 0)
    'color-discipline-harness-racing-secondary': '#571305', // rgb(87, 19, 5)
    'color-discipline-reining-main': '#FF7105', // rgb(255, 113, 5)
    'color-discipline-reining-secondary': '#D1A366', // rgb(209, 163, 102)
    'color-discipline-barrel-racing-main': '#FF7105', // rgb(255, 113, 5)
    'color-discipline-barrel-racing-secondary': '#D1A366', // rgb(209, 163, 102)
    'color-discipline-gymnastics-main': '#FF61E5', // rgb(255, 97, 229)
    'color-discipline-gymnastics-secondary': '#F5D1F2', // rgb(245, 209, 242)
    'color-discipline-flat-work-main': '#00FFF7', // rgb(0, 255, 247)
    'color-discipline-flat-work-secondary': '#0090AD', // rgb(0, 144, 173)
    'color-discipline-outriding-main': '#02CF9F', // rgb(2, 207, 159)
    'color-discipline-outriding-secondary': '#003319', // rgb(0, 51, 25)
    'color-discipline-default-main': '#6655FF', // rgb(102, 85, 255)
    'color-discipline-default-secondary': '#FFFFFF1F', // rgba(255, 255, 255, 0.12)
}

const palette = {
    'color-palette-1': '#F72586',
    'color-palette-2': '#4BC9F1',
    'color-palette-3': '#FDE441',
    'color-palette-4': '#80EE98',
    'color-palette-5': '#EF4444',
    'color-palette-6': '#FF8C00',
    'color-palette-7': '#D2B48C',
    'color-palette-8': '#ADFF2F',
    'color-palette-9': '#20B2AA',
    'color-palette-10': '#4169E1',
    'color-palette-11': '#FF69B4',
    'color-palette-12': '#FA8072',
    'color-palette-13': '#F5DEB3',
    'color-palette-14': '#32CD32',
    'color-palette-15': '#FFD700',
    'color-palette-16': '#00CED1',
    'color-palette-17': '#BDB76B',
    'color-palette-18': '#FF6347',
    'color-palette-19': '#87CEEB',
    'color-palette-20': '#CD853F',
    'color-palette-21': '#98FB98',
    'color-palette-22': '#FFA07A',
}

const primevue = {
    'primevue-primary-hover': '#4050C2',
    'primevue-primary-highlight-opacity': '0.1',
    'primevue-primary-50': '#EEF0FF',
    'primevue-primary-100': '#D8DFFF',
    'primevue-primary-200': '#B3BFFF',
    'primevue-primary-300': '#8C9FFF',
    'primevue-primary-400': '#667EFF',
    'primevue-primary-500': '#5060F1',
    'primevue-primary-600': '#4050C2',
    'primevue-primary-700': '#303F99',
    'primevue-primary-800': '#202F70',
    'primevue-primary-900': '#101F47',
    'primevue-primary-950': '#08102B',

    'primevue-surface-0': '#FFFFFF',
    'primevue-surface-50': '#FAFAFA',
    'primevue-surface-100': '#F4F4F5',
    'primevue-surface-200': '#E4E4E7',
    'primevue-surface-300': '#D4D4D8',
    'primevue-surface-400': '#A1A1AA',
    'primevue-surface-500': '#848890',
    'primevue-surface-600': '#71717A',
    'primevue-surface-700': '#4B4C50',
    'primevue-surface-800': '#3D3E42',
    'primevue-surface-900': '#303032',
    'primevue-surface-950': '#1C1D1F',

    // // Refs to other tokens
    // 'primevue-primary': 'rgb(var(--primary-500))',
    // 'primevue-primary-inverse': 'rgb(var(--surface-0))',
    // 'primevue-primary-hover': 'rgb(var(--primary-600))',
    // 'primevue-primary-active-color': 'rgb(var(--primary-600))',
    // 'primevue-primary-highlight-inverse': 'rgb(var(--primary-700))',
    // 'primevue-primary-highlight-hover-opacity': '0.2',
}

export const theme = {
    ...font,
    ...base,
    ...dark,
    ...text,
    ...border,
    ...brand,
    ...state,
    ...custom,
    ...banner,
    ...button,
    ...gaits,
    ...polar,
    ...gradient,
    ...discipline,
    ...palette,
    ...primevue,
}
